/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2023 - 2025
///                                   RXO Inc.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of RXO Inc. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import { useState } from "react";
import messages from "../../../helpers/messages";
import { commitmentPeriods } from "../../../helpers/types";
import InfoIcon from "../../icons/InfoIcon";
import Tooltip from "../../Tooltip";
import Modal from "../../Modal";
import AutoComplete from "../../form-controls/AutoComplete";

function ShipperRatesAwardTemplateOptionsModal({
  bidId,
  handleClose,
  handleDownload
}) {
  const [commitment, setCommitment] = useState(1);
  const [includeNonPrimary, setIncludeNonPrimary] = useState(false);
  const [replaceV, setReplaceV] = useState(false);

  return (
    <Modal
      title={messages.shipperRatesAwardTemplateTitle.defaultMessage}
      open={true}
      handleClose={() => handleClose(false)}
      titleClass="modal__title_light uppercase"
      bodyClass="border-top-grey px-24 pt-24 award-upload"
      closeButtonClass="modal__close-button mr-16 mt-16"
      large={true}
    >
      <div>
        <form>
          <table className="card display-table one-whole">
            <tbody>
              <tr className="row">
                <th className="three-quarters py-16 pl-28">
                  <p data-testid="replace van">
                    {
                      messages.shipperRatesAwardTemplateEquipmentType
                        .defaultMessage
                    }
                  </p>
                </th>
                <td className="one-quarter py-16 pos-relative">
                  <input
                    className="pointer pos-absolute mt-2"
                    type="checkbox"
                    onChange={({ target }) => setReplaceV(target.checked)}
                  />
                </td>
              </tr>
              <tr className="row">
                <th className="one-half py-16 pl-28">
                  <p data-testid="non primary">
                    {
                      messages.shipperRatesAwardTemplateNonPrimaryLanes
                        .defaultMessage
                    }
                  </p>
                </th>
                <td className="one-half py-16 pos-relative">
                  <input
                    className="pointer pos-absolute mt-2"
                    type="checkbox"
                    onChange={({ target }) =>
                      setIncludeNonPrimary(target.checked)
                    }
                  />
                </td>
              </tr>
              <tr className="row">
                <th className="one-half py-16 pl-28">
                  <p>
                    <span data-testid="commitment period">
                      {messages.commitmentPeriod.defaultMessage}
                    </span>
                    <Tooltip
                      content={messages.commitmentPeriodTooltip.defaultMessage}
                      offset={[0, 0]}
                    >
                      <span>
                        <InfoIcon
                          className="align-top ml-12"
                          width="16px"
                          height="16px"
                          title=""
                          placement="right-start"
                        />
                      </span>
                    </Tooltip>
                  </p>
                </th>
                <td className="one-half py-16 pos-relative">
                  <AutoComplete
                    handleChange={target => setCommitment(target.value)}
                    value={commitmentPeriods.find(x => x.value === commitment)}
                    staticOptions={commitmentPeriods}
                    data-testid="commitment select"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <button
            type="button"
            className="primary-button fr univers-67-bold-cond mt-12 mb-24 mr-12 px-16 short-button"
            onClick={() => {
              handleDownload({
                bidId: bidId,
                replaceV: replaceV,
                includeNonPrimary: includeNonPrimary,
                commitmentPeriod: commitment
              });
              handleClose(false);
            }}
            data-testid="download"
          >
            {messages.download.defaultMessage}
          </button>
          <button
            onClick={() => handleClose(false)}
            className="secondary-button fr univers-67-bold-cond mt-12 mb-24 mr-12 px-16 short-button"
            data-testid="cancel"
          >
            {messages.cancel.defaultMessage}
          </button>
        </form>
      </div>
    </Modal>
  );
}

export default ShipperRatesAwardTemplateOptionsModal;
